<template><div class="settings main flex">
  <sticky-bar>Settings</sticky-bar>
  <div class="flex-fill padded">
    <div class="fleet-list">
      <router-link to="/s/me">My Account</router-link>
      <router-link to="/s/uac" v-if="isAccountOwner">User Access Control</router-link>
    </div>
    <template v-if="fleets.length">
      Fleet Settings:
      <div class="fleet-list">
        <router-link v-for="(f,i) in fleets" :key="`f-${i}`" v-html="f.name" :to="`/s/f/${f.id}`" />
      </div>
    </template>
  </div>
</div></template>
<script>
import { mapState } from 'vuex'
import StickyBar from '../StickyBar'
export default {
  name: 'settings',
  components: { StickyBar },
  computed: {
    fleets() {
      let ff = this.$store.getters.fleets,
        fids = this.$store.getters.myManagedFleets.slice()
      fids.sort((a,b) => ((ff[a].name < ff[b].name) ? -1 : ((ff[a].name > ff[b].name) ? 1 : 0)))
      return fids.map(fid => ff[fid])
    },
    ...mapState({
      isAccountOwner: state => state.permissions && state.permissions.isAccountOwner || false,
    })
  },
}
</script>
<style lang="scss" scoped>
.settings {
  .fleet-list {
    padding: 5px 0;
    a {
      display: inline-block;
      margin: 0 5px 5px 0;
      text-decoration: none;
      border-radius: 5px;
      background: #ccc;
      padding: 5px 10px;
    }
  }
}
</style>
